import { render, staticRenderFns } from "./HistoricoFaturamentoChart.vue?vue&type=template&id=eb6554fc"
import script from "./HistoricoFaturamentoChart.vue?vue&type=script&lang=js"
export * from "./HistoricoFaturamentoChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports